var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ok-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#079fac",
    d: "M9.703 29.006c-0.413 0-0.826-0.206-1.135-0.516l-8.052-9.187c-0.516-0.619-0.516-1.652 0.103-2.168s1.652-0.516 2.168 0.103l6.813 7.845 3.819-4.439c0.516-0.619 1.548-0.723 2.168-0.103 0.619 0.516 0.723 1.548 0.103 2.168l-4.955 5.677c-0.103 0.413-0.516 0.619-1.032 0.619zM19.716 17.548c-0.31 0-0.723-0.103-1.032-0.413-0.619-0.516-0.723-1.548-0.103-2.168l10.013-11.458c0.516-0.619 1.548-0.723 2.168-0.103 0.619 0.516 0.723 1.548 0.103 2.168l-10.013 11.458c-0.31 0.31-0.723 0.516-1.135 0.516z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkIcon);
export default __webpack_public_path__ + "static/media/ok-icon.da800e00b39f10891edfa0605d2861f7.svg";
export { ForwardRef as ReactComponent };